import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { DialpadComponent } from "./dialpad.component";

@NgModule({
  imports: [
    SharedModule,
  ],
  declarations: [
    DialpadComponent
  ],
  exports: [
    DialpadComponent
  ],
  providers: [
  ]
})
export class DialpadModule {
  constructor() {
  }
}
